import {Controller} from "stimulus"
import AutoNumeric from "autonumeric";
import {showCartError, showCartMessage, withValidCart} from "./cart_validity";
import {showFlash} from "../helpers/flash";
// import Honeybadger from 'honeybadger-js';

let autoNumericList = [];
let autoNumericBalance;
let autoNumericCartTotal;
let cartIdentifier;
let loopRunning = false;
export default class extends Controller {

    // The refresh state belongs to this checkout, not to the page: Turbo can
    // disconnect this controller while a refresh is still in flight, and the
    // answer must not reach the checkout that replaced it.
    initialize() {
        // Which posting-date refresh is the live one. A teller clicking through
        // dates fires one per click and the answers can land in any order; only
        // the newest describes the date the input still shows and the checkout
        // will submit.
        this.latestPostDateRefresh = 0;
        // The request the newest selection is waiting on, kept so the next
        // selection can abort it: refresh_cart re-dates the checkout and
        // re-prices every line server-side, so a superseded request is not
        // merely a stale answer.
        this.postDateRefreshInFlight = null;
        // The date the cart was last actually priced for. A refusal puts the
        // input back to it rather than leaving the picker showing a date
        // nothing was priced against.
        this.acceptedPostingDate = null;
        // Bound once so connect and disconnect add and remove the same listener.
        // Bound to the submission rather than to a click: the Remove control is a
        // div inside a submit button, so a mouse click targets the div while a
        // keyboard activation targets the button — the form's own submit event is
        // the one thing both go through.
        this.refuseCartRemovalWhileCardIsCommitted = (event) => {
            if (!event.target.querySelector || !event.target.querySelector(".remove-cart-icon")) {
                return;
            }
            if (refuseCartChangeWhileCardIsCommitted()) {
                event.preventDefault();
                event.stopPropagation();
            }
        };
    }

    connect() {
        console.log("log from checkoutPayments controller");
        const amountDue = Number(window.checkoutMiniCartCartTotal.innerHTML.replace("$", "").replace(",", "").trim());
        let tenderedFields = document.querySelectorAll(".tendered-field")
        let workingTenderedField = tenderedFields[tenderedFields.length - 1];
        cartIdentifier = this.data.get("cart");
        this.acceptedPostingDate = postingDateOnPage();
        workingTenderedField.value = amountDue;
        autoNumericBalance = new AutoNumeric('#balanceAmount', {currencySymbol: '$'});
        autoNumericCartTotal = new AutoNumeric('#cart-total', {currencySymbol: '$'});
        updateBalance();
        autoNumericList = new AutoNumeric.multiple(".tendered-field", ['NorthAmerican', {unformatOnSubmit: true}]);
        window.miniTeller.classList.add('teller-show')
        // The Remove control on a cart line is a plain form submit rather than a
        // Stimulus action, so the refusal intercepts the submission itself — in
        // the capture phase, which reaches this element before Turbo's own
        // document-level handler gets the event.
        this.element.addEventListener("submit", this.refuseCartRemovalWhileCardIsCommitted, true);
    }

    // Stimulus disconnects this controller when Turbo navigates away, and the
    // refresh it left running would otherwise re-date a checkout nobody is
    // looking at and repaint whatever cart is on screen when it lands. Both are
    // stopped here: the request goes, and the sequence moves past any answer
    // still on its way back.
    disconnect() {
        this.element.removeEventListener("submit", this.refuseCartRemovalWhileCardIsCommitted, true);
        this.latestPostDateRefresh++;
        if (this.postDateRefreshInFlight) {
            this.postDateRefreshInFlight.abort();
            this.postDateRefreshInFlight = null;
        }
    }

    addPayment(e) {
        const paymentsArea = document.querySelector(".co-working-payment");
        console.log("payment addeded!");
        fetch("/cr_payments/add_payment?cart=" + cartIdentifier)
            .then(response => response.text())
            .then(html => {
                    console.log(html);
                    paymentsArea.insertAdjacentHTML("beforeEnd", html);
                    paymentsArea.lastElementChild.querySelector(".tendered-field").value = autoNumericBalance.getNumericString();
                    new AutoNumeric(paymentsArea.lastElementChild.querySelector(".tendered-field"), ['NorthAmerican', {unformatOnSubmit: true}]);
                    updateBalance();
                }
            );

    }

    postDateSelect(e) {
        console.log("posting date changed!");
        const postingDate = document.getElementById('when_booked').value;
        const postDateArea = e.target.closest(".posting-date-form");
        // Once a card intent exists the amount it will take is settled, and so
        // is the date that priced it. That is true from the moment the card
        // form is asked for, not just after the capture: the intent is created
        // for the total showing then, and re-pricing inside the confirmation
        // window moves the cart total and re-tenders the field while the intent
        // stays where it was — the checkout would book an amount the gateway
        // never took. Either way re-pricing leaves a balance the card cannot be
        // asked for again or an overpayment the post cannot settle, since change
        // comes only from cash, so the date change is refused before the server
        // re-prices anything. The refusal has to live here: an intent belongs to
        // its own payment record and nothing ties it to this cart until the
        // checkout is submitted, so the server cannot answer the question yet.
        if (cardPaymentIsCommitted()) {
            // A refresh already on its way back would repaint and re-price the
            // cart after the gateway settled against the old total, and
            // suppressing its answer is not enough — refresh_cart re-dates the
            // checkout server-side — so it goes down with this selection.
            this.latestPostDateRefresh++;
            if (this.postDateRefreshInFlight) {
                this.postDateRefreshInFlight.abort();
                this.postDateRefreshInFlight = null;
            }
            this.restoreAcceptedPostingDate();
            // Not showCartError: a captured card can be a part tender, and the
            // teller still has cash to add and an Apply Payments to press. The
            // date is refused here, not the cart.
            showCartMessage(cardCommitmentRefusal("The posting date"));
            closePostingDateEditor(postDateArea);
            return Promise.resolve();
        }
        const refreshSequence = ++this.latestPostDateRefresh;
        if (this.postDateRefreshInFlight) {
            this.postDateRefreshInFlight.abort();
        }
        this.postDateRefreshInFlight = new AbortController();
        // Returned so the abort handling below is a promise the caller can
        // wait on rather than a chain running loose.
        return fetch("/carts/" + cartIdentifier + "/refresh_cart?booked_on=" + postingDate,
            {signal: this.postDateRefreshInFlight.signal})
            // The server refuses to re-date a checkout that has already booked
            // to the G/L. Its error body is JSON, and rendering that where the
            // cart belongs would replace the teller's cart with an error
            // object — surface the refusal here and hand the success handler a
            // null to stand down on. Deliberately not a trailing .catch: that
            // would also swallow a DOM slip on the happy path, where the cart
            // has already been re-priced and hiding Apply Payments would lock
            // the teller out of a perfectly valid cart.
            .then(response => {
                // A slower answer for a date the teller has already moved on
                // from would repaint the cart under the newer one: they would
                // read one total and post another.
                if (refreshSequence !== this.latestPostDateRefresh) {
                    return null;
                }
                if (response.ok) {
                    return response.text();
                }
                return response.json()
                    .catch(() => ({}))
                    .then(data => {
                        // Parsing the refusal body is another turn of the loop,
                        // and a newer selection can land inside it. A refusal
                        // for a date the teller has moved on from is not the
                        // state of the cart they are looking at — and applying
                        // it here would revert the newer date and close its
                        // editor on top of that.
                        if (refreshSequence !== this.latestPostDateRefresh) {
                            return null;
                        }
                        // The server kept the date the cart was already priced
                        // for, so the picker goes back to it and the editor
                        // closes on it: a refused date left on screen reads as
                        // the cart's own, and it is the date the checkout would
                        // submit.
                        this.restoreAcceptedPostingDate();
                        closePostingDateEditor(postDateArea);
                        showCartError(data.message || "Unable to change the posting date. Please refresh the page and try again.");
                        return null;
                    });
            })
            .then(html => {
                    if (html === null || refreshSequence !== this.latestPostDateRefresh) {
                        return;
                    }
                    document.querySelector('.cart-detail').innerHTML = html;
                    this.acceptedPostingDate = postingDate;
                    updateBalance();
                    // A posting date across a rate boundary changes the total, so
                    // the tender has to follow it — same as every other handler
                    // that replaces the cart.
                    updatePayment();
                    let newPostingDate = new Date(postingDate + ' est');
                const today = new Date();
                    // Everything below here is chrome — the cart has already
                    // been re-priced and re-tendered above. A missing node is
                    // not worth throwing over, and definitely not worth
                    // interrupting a teller mid-payment for.
                    const dateDisplay = postDateArea?.closest(".posting-date-control")?.querySelector(".posting-date-display");
                    if (dateDisplay) {
                        dateDisplay.innerText = newPostingDate.toLocaleDateString("en-US");
                        if (newPostingDate.getDate() === today.getDate()) {
                            dateDisplay.classList.remove('alert-date')
                        } else {
                            dateDisplay.classList.add('alert-date')
                        }
                    }

                    closePostingDateEditor(postDateArea);
                }
            )
            // Aborting a superseded request rejects its fetch. That rejection
            // is ours — we asked for it — so it is swallowed here rather than
            // left to surface as an unhandled rejection. Nothing else is: a
            // network failure or a DOM slip is a real fault and goes on up.
            .catch(error => {
                if (error.name !== "AbortError") {
                    throw error;
                }
            })
    }

    // Puts the posting-date field back to the date the cart was last priced for.
    // #when_booked is a flatpickr input, and setting its value alone would leave
    // the calendar's own selectedDates on the date just refused: the field and
    // the highlighted day would disagree, and picking that day again fires no
    // change event, so the teller could not re-choose it. setDate's second
    // argument is false because this is a rollback, not a selection — firing
    // change here would call straight back into postDateSelect. It leaves a date
    // in the field either way, so the clear button's visibility is unchanged.
    restoreAcceptedPostingDate() {
        const field = document.getElementById('when_booked');
        if (!field) {
            return;
        }
        if (field._flatpickr) {
            field._flatpickr.setDate(this.acceptedPostingDate, false);
        } else {
            field.value = this.acceptedPostingDate;
        }
    }

    postStripe() {
        if (loopRunning === true) {
            console.log("Already Checking; aborting...")
        } else {
            loopRunning = true;
            console.log("starting check for stripe completion")
            loopPaymentlinesCheck(cartIdentifier)
        }

    }

    addAdjustment(e) {
        if (refuseCartChangeWhileCardIsCommitted()) {
            return;
        }
        const cartItem = e.target.closest(".cart-row").querySelector(".cart-item-id")
        const cartItemId = makeNumber(cartItem.innerHTML);
        console.log("adjustment addeded!");
        fetch("/cr_adjustments/add_adjustment?cart_item_id=" + cartItemId)
            .then(response => response.text())
            .then(html => {
                    cartItem.closest("td").insertAdjacentHTML("beforeEnd", html);
                    const adjustmentFields = document.querySelectorAll(".adjustment-field");
                    const lastAdjustmentField = adjustmentFields[adjustmentFields.length - 1];
                    new AutoNumeric(lastAdjustmentField, ['NorthAmerican', {unformatOnSubmit: true}]);
                    updateBalance();
                    updateCartItemAdjustedBalances();
                }
            );
    }

    adjustmentSubmitEnable(e) {
        const formArea = e.target.closest(".cr-adjustment-fields");
        const depositAmountPresent = AutoNumeric.getNumber(formArea.querySelector(".cr-adj-amount"));
        const adjustmentMemoDescriptionPresent = formArea.querySelector(".cr-adj-description").value.length > 0
        const memoSubmitButton = formArea.querySelector(".cr-adj-add-button");
        memoSubmitButton.disabled = !(adjustmentMemoDescriptionPresent && depositAmountPresent);

    }


    removeAdjustment(e) {
        e.preventDefault();
        if (refuseCartChangeWhileCardIsCommitted()) {
            return;
        }
        if (!confirm(e.target.closest('a').dataset.confirm)) return;

        const adjustmentId = e.target.closest('a').dataset.adjustmentId;
        const adjustmentLine = e.target.closest('.cr-adjustment-line');

        fetch(`/cr_adjustments/${adjustmentId}`, {
            method: 'DELETE',
            headers: {
                'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
            },
        })
            .then(response => {
                if (response.ok) {
                    adjustmentLine.remove();
                    updateCartItemAdjustedBalances();
                    updateBalance();
                    updatePayment();
                }
            });
    }


    updateBalance(e) {
        e.preventDefault();
        updateBalance()
        autoNumericList.map(function (element) {
            element.set
        });
    }

    submitAdjustment(e) {
        e.preventDefault();
        if (refuseCartChangeWhileCardIsCommitted()) {
            return;
        }
        const descriptionField = e.target.closest(".cr-adjustment-fields").querySelector(".cr-adj-description");
        const amountField = AutoNumeric.unformat(e.target.closest(".cr-adjustment-fields").querySelector(".cr-adj-amount"), 'NorthAmerican');
        const cartItemId = e.target.closest(".cart-row").querySelector(".cart-item-id").innerHTML;
        if (amountField.length > 0 && descriptionField.value.length > 0) {
            fetch("/cr_adjustments?cart_item_id=" + cartItemId, {
                method: 'POST',
                credentials: "same-origin",
                headers: {
                    "X-CSRF-Token": document.getElementsByName('csrf-token')[0].content,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({amount: amountField, description: descriptionField.value})
            }).then(response => response.text())
                .then((html) => {
                    console.log('adjustment created; updating cart');
                    document.querySelector(".cart-detail").innerHTML = html;
                    updateCartItemAdjustedBalances();
                    updateBalance();
                    updatePayment();
                })
                .catch((error) => {
                        console.warn(error);
                    // Honeybadger.notify(error)
                        showFlash([{type: "alert", text: error.message}]);

                    }
                )
        }
    }

    removePaymentLine(e) {
        const paymentLine = e.target.closest(".payment-line");
        if (refusePaymentLineChange(paymentLine)) {
            return;
        }
        paymentLine.parentNode.removeChild(paymentLine);
        updateBalance();
        updatePayment();
    }

    setPaymentFields(e) {
        console.log("paymentField Changed");
        let payLineArea = e.target.closest(".payment-line");
        if (refusePaymentLineChange(payLineArea)) {
            return;
        }
        const model = payLineArea.querySelector(".payment-select").value;
        const currentAmount = makeNumber(payLineArea.querySelector(".tendered-field").value);
        var template = document.createElement('template');
        withValidCart(cartIdentifier, function () {
            fetch("/cr_payments/add_payment?type=" + model + "&amount_tendered=" + currentAmount + "&cart=" + cartIdentifier)
                .then(response => response.text())
                .then(html => {
                    html = html.trim();
                    template.innerHTML = html
                    const insertElement = template.content.firstChild;
                    payLineArea.parentNode.replaceChild(insertElement, payLineArea)
                    const paymentField = new AutoNumeric(insertElement.lastElementChild.querySelector(".tendered-field"), ['NorthAmerican', {unformatOnSubmit: true}]);
                    paymentField.set(currentAmount);
                    updateBalance();
                });
        });
    }

    applyPayments(e) {
        if (!cartHasItems()) {
            alert("Cannot process payment without charges in cart.");
            return false;
        }
        console.log("checking for negative non-cash balance")
        if (makeNumber(document.getElementById("balanceAmount").innerText) < 0.0 &&
            !sufficientCashForChange()
        ) {
            alert("Change can only be given from cash payments. Please adjust the payment amount or add a cash payment to cover the change due.");
            return false;
        }
        console.log("applying payments")
        e.target.disabled = true;
        withValidCart(cartIdentifier, function () {
            postPayments(cartIdentifier);
        });
    }


    waivePenalty(e) {
        e.preventDefault();
        if (refuseCartChangeWhileCardIsCommitted()) {
            return;
        }
        const penaltyId = e.target.closest(".cr-adjustment-line").querySelector(".penalty-id").value;
        const postingDate = document.getElementById('when_booked').value;
        const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
        const body = new URLSearchParams({ penalty_id: penaltyId, booked_on: postingDate });
        fetch("/carts/" + cartIdentifier + "/waive_penalty", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8", "X-CSRF-Token": csrfToken },
            body: body,
            credentials: "same-origin"
        })
            .then(response => {
                if (!response.ok) throw new Error("Failed to waive penalty (status " + response.status + ")");
                return response.text();
            })
            .then(html => {
                document.querySelector('.cart-detail').innerHTML = html;
                updateBalance();
                updatePayment();
                console.log("waiving penalty");
                return false;
            })
            .catch(error => console.error("Error waiving penalty:", error));
        return false;
    }

    unwaivePenalty(e) {
        e.preventDefault();
        if (refuseCartChangeWhileCardIsCommitted()) {
            return;
        }
        if (!confirm("Are you sure you want to restore this penalty?")) return;
        const penaltyId = e.target.closest(".cr-adjustment-line").querySelector(".penalty-id").value;
        const postingDate = document.getElementById('when_booked').value;
        const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
        const body = new URLSearchParams({ penalty_id: penaltyId, booked_on: postingDate });
        fetch("/carts/" + cartIdentifier + "/unwaive_penalty", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8", "X-CSRF-Token": csrfToken },
            body: body,
            credentials: "same-origin"
        })
            .then(response => {
                if (!response.ok) throw new Error("Failed to unwaive penalty (status " + response.status + ")");
                return response.text();
            })
            .then(html => {
                document.querySelector('.cart-detail').innerHTML = html;
                updateBalance();
                updatePayment();
                console.log("unwaiving penalty");
                return false;
            })
            .catch(error => console.error("Error unwaiving penalty:", error));
        return false;
    }

}

function updateBalance() {
    console.log("updating balance");
    const totalDue = amountPaid(document.querySelectorAll(".line-amount")) +
        amountPaid(document.querySelectorAll(".adjustment-field")) +
        amountPaid(document.querySelectorAll(".adjustment-line-amount")) -
        amountPaid(document.querySelectorAll(".paid-amount"))
    const totalPaying = amountPaid(document.querySelectorAll(".tendered-field"));
    const balance = (totalDue - totalPaying).toFixed(2)
    document.getElementById('cart-total').innerText = totalDue.toFixed(2);
    autoNumericBalance.set(balance);
    autoNumericCartTotal.set(totalDue);
    if (paymentLinesReady() && tellerAssigned() && cartHasItems()) {
        document.querySelector("#apply-payments-button").classList.remove('hidden')
    } else {
        document.querySelector("#apply-payments-button").classList.add('hidden')

    }
}

function updateCartItemAdjustedBalances() {
    Array.from(document.querySelectorAll(".cart-row")).map(el => {
            if (el.querySelector(".adjusted-line-amount")) {
                const initialAmount = amountPaid(el.querySelectorAll(".line-amount"))
                const adjustments = amountPaid(el.querySelectorAll(".adjustment-line-amount"))
                if (adjustments !== 0) {
                    el.querySelector(".adjusted-line-amount").innerText = "$" + (initialAmount + adjustments).toFixed(2)
                } else {
                    el.querySelector(".adjusted-line-amount").innerText = ""
                }
            }
        }
    )
}

export function amountPaid(elements) {
    // console.log(elements);
    const totalAmount = Array.prototype.slice.call(elements).reduce(function (total, element) {
        let stringValue;
        if (element.value) {
            stringValue = element.value
        } else {
            stringValue = element.innerText
        }
        // console.log("adding: " + stringValue)
        return total + makeNumber(stringValue);
    }, 0.0);
    return totalAmount;
}


function paymentLinesReady() {
    return Array.prototype.slice.call(document.querySelectorAll(".ready-to-pay")).every(function (element) {
        return element.innerText == "true"
    })
}

function paymentCancelled() {
    return (document.querySelector(".cc-manual-fields").querySelector("#cancelled").value == "true")
}

function loopPaymentlinesCheck(cartIdentifier) {
    console.log("checking if stripe is ready")
    if (paymentCancelled()) {
        loopRunning = false;
        return
    } else if (paymentLinesReady()) {
        loopRunning = false;
        updateBalance();
        if (cartFullyPaid()) {
            postPayments(cartIdentifier);
        } else {
            const oldPaymentArea = document.querySelector(".stripe-payment-form-area");
            const oldbutton = document.querySelector(".card-detail-button");
            oldPaymentArea.classList.remove("stripe-payment-form-area");
            oldPaymentArea.classList.add("stripe-payment-form-area-completed");
            oldbutton.classList.remove("card-detail-button");
        }
        return
    } else {
        setTimeout(function () {
            loopPaymentlinesCheck(cartIdentifier)
        }, 500)
    }
}

function tellerAssigned() {
    return document.getElementById('current_teller_id').value.length > 0;
}

function collectPayments() {
    return Array.prototype.slice.call(document.querySelector(".payments-area").querySelectorAll(".payment-partial")).map(function (paymentLine) {
        const model = paymentLine.querySelector(".klass").innerText;
        const valueSet = Array.prototype.slice.call(paymentLine.querySelectorAll("input[type=text], input[type=hidden]")).map(function (inputSet) {
            let tempSet = {};
            let cleanValue = "";
            if (inputSet.value[0] === "$" || inputSet.value[1] === "$") {
                cleanValue = makeNumber(inputSet.value)
            } else {
                cleanValue = inputSet.value
            }
            tempSet[inputSet.name] = cleanValue;
            return tempSet
        });
        let returnHash = {};
        returnHash['klass'] = model;
        returnHash['params'] = valueSet;
        return returnHash;
    });
}

export function makeNumber(textVal) {
    return Number(textVal.replace("$", "").replaceAll(",", "").trim());
}

function cartFullyPaid() {
    return makeNumber(document.getElementById('balanceAmount').innerText) === 0.0
}

// Puts the posting-date control back the way it was found, whether the date
// was taken or refused.
function closePostingDateEditor(postDateArea) {
    postDateArea?.classList.remove("editing");
    document.querySelector(".flatpickr-calendar")?.classList.remove("open");
}

// The posting date the page is showing. #when_booked is rendered blank and its
// own flatpickr controller applies the default when that child controller
// connects, which is after this one: reading .value alone at connect caches an
// empty string as the accepted date, and a later refusal would then roll the
// picker back to nothing and leave the checkout with no date to submit. The
// default the field carries is the same date flatpickr is about to apply,
// trimmed to the Y-m-d the picker renders in.
function postingDateOnPage() {
    const field = document.getElementById('when_booked');
    if (!field) {
        return null;
    }
    return field.value || (field.dataset.flatpickrDefaultDate || "").slice(0, 10) || null;
}

// A card line reads ready only once the gateway has captured it — cr-otc-cc and
// cr-cc-terminal flip it on a succeeded payment intent, and nothing else sets a
// card line ready. The money is gone by then and the browser cannot re-authorize
// it, so the amount it was charged for stays put: posting a different figure
// would book a ledger payment the card never took. A re-price after a capture
// stands as a balance for the teller to settle instead.
function capturedCardPayment() {
    return Array.prototype.slice.call(document.querySelectorAll(".cc-manual-fields .ready-to-pay"))
        .some(function (marker) {
            return marker.innerText.trim() === "true";
        });
}

// Whether a card line has an intent open on it. Two markers, because the amount
// is fixed before the client secret comes back: cr-otc-cc and cr-cc-terminal
// stamp the line when they ask the server for the card form, which is when the
// intent is created for the total showing then, and the client secret the server
// renders answers for the window after that. A line that has already been taken
// loses its form area to the completed one, and capturedCardPayment answers for
// it.
function pendingCardIntent() {
    return document.querySelector(".cc-manual-fields[data-card-intent='requested']") != null ||
        document.querySelector(".cc-manual-fields .stripe-payment-form-area #stripe-key") != null;
}

// Whether the cart total is the gateway's now rather than the teller's. Either
// end of the card counts: an intent waiting on a confirmation is quoted at the
// amount it was created for just as firmly as one already captured.
function cardPaymentIsCommitted() {
    return capturedCardPayment() || pendingCardIntent();
}

// The refusal this checkout owes for a change the gateway's hold does not allow,
// or null when nothing is holding it. Two different refusals, because the ways
// out differ: an intent that was never confirmed took no money and its line can
// still come off the checkout, while a capture cannot be undone from here.
function cardCommitmentRefusal(subject) {
    if (capturedCardPayment()) {
        return subject + " cannot be changed after a card payment has been taken.";
    }
    if (pendingCardIntent()) {
        return subject + " cannot be changed while a card payment is pending. Remove the card payment line first.";
    }
    return null;
}

// Refuses a change to the cart while a card is committed and answers whether it
// did. Adding an adjustment, waiving a penalty or taking a charge off the cart
// all move the total the gateway was quoted, leaving either a balance the card
// cannot be asked for again or an overpayment the post cannot settle.
function refuseCartChangeWhileCardIsCommitted() {
    const refusal = cardCommitmentRefusal("The cart");
    if (refusal) {
        showCartMessage(refusal);
    }
    return refusal != null;
}

// Whether this payment line is a card the gateway has already taken. The line
// carries the gateway's reference, and it is the only record of that charge on
// the page: removing the line or replacing it with another tender type posts
// the checkout without the payment that charged the customer.
function capturedCardPaymentLine(paymentLine) {
    const cardFields = paymentLine && paymentLine.closest(".cc-manual-fields");
    if (!cardFields) {
        return false;
    }
    return Array.prototype.slice.call(cardFields.querySelectorAll(".ready-to-pay"))
        .some(function (marker) {
            return marker.innerText.trim() === "true";
        });
}

// Refuses a change to one payment line the gateway has taken and answers whether
// it did. Scoped to the line rather than the page: a cash line beside a captured
// card is still the teller's to correct.
function refusePaymentLineChange(paymentLine) {
    if (!capturedCardPaymentLine(paymentLine)) {
        return false;
    }
    showCartMessage("This payment line cannot be changed after a card payment has been taken.");
    return true;
}

function updatePayment() {
    if (cardPaymentIsCommitted()) {
        return;
    }
    if (!cartFullyPaid() && document.querySelectorAll(".tendered-field").length == 1) {
        console.log("matching payment to total");
        const tenderedField = AutoNumeric.getAutoNumericElement(".tendered-field");
        const tenderedDomField = document.querySelector(".tendered-field");
        var event = new Event('change');
        tenderedField.set(document.getElementById('cart-total').innerText);
        tenderedDomField.dispatchEvent(event);
        updateBalance();
    }
}

export function sufficientCashForChange() {
    return amountPaid(document.querySelectorAll("[data-tender-type='cash']")) >= (makeNumber(document.getElementById("balanceAmount").innerText) * -1)
}

export function cartHasItems() {
    return document.querySelector(".cart-row") != null;
}

function postPayments(cartIdentifier) {
    document.getElementById("apply-payments-button").setAttribute("disabled", "disabled");
    let paymentsJSON = collectPayments();
    const totalDue = makeNumber(document.getElementById('cart-total').innerText);
    const totalPaying = amountPaid(document.querySelectorAll(".tendered-field"));
    const balance = (totalDue - totalPaying).toFixed(2);
    const whenBooked = document.getElementById('when_booked').value;
    let selectedRecipients = [];
    if (document.getElementById('recipients')) {
        selectedRecipients = Array.from(document.getElementById('recipients').options).filter(option => option.selected).map(option => option.value);
    }
    let emailRecipients = selectedRecipients.concat(document.getElementById('dynamic_recipient').value.split(/[;,]/).map(e => e.trim()));
    let checkout = {klass: "Checkout", params: {}};
    checkout['params']['cart_id'] = cartIdentifier;
    checkout['params']['totalDue'] = totalDue;
    checkout['params']['totalPaying'] = totalPaying;
    checkout['params']['balance'] = balance;
    checkout['params']['when_booked'] = whenBooked;
    checkout['params']['recipients'] = emailRecipients;
    paymentsJSON.push(checkout);
    console.log(paymentsJSON);
    fetch('/carts/' + cartIdentifier + '/checkouts', {
        method: 'POST',
        credentials: "same-origin",
        headers: {
            "X-CSRF-Token": document.getElementsByName('csrf-token')[0].content,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(paymentsJSON)
    }).then(response => {
        return response.json().then(data => {
            if (!response.ok) {
                // The rejection lands in the catch below, which shows the message.
                document.getElementById("apply-payments-button").disabled = false;
                return Promise.reject(new Error(data.message || "An error occurred"));
            }
            return data;
        });
    }).then((data) => {
        console.log(data);
        Turbo.cache.clear();
        if (data['result'] === "success") {
            const warnings = (data['warnings'] || []).map(warning => ({type: "warning", text: warning}));
            showFlash([{type: "notice", text: data['message']}].concat(warnings));
            document.querySelector('#apply-payments-button').classList.add('hidden');
            window.checkoutMiniCart.classList.add('hidden');
            document.querySelector(".co-working-payment").classList.add('hidden');
            document.querySelector(".co-add-payment").classList.add('hidden');
            document.querySelector(".co-working-payment").classList.add('hidden');
            document.querySelector(".email-receipt").classList.add('hidden');
            Array.from(document.querySelectorAll('.waive-penalty')).map(function (el) {
                el.classList.add('hidden')
            })
            const hideElements = Array.from(document.querySelectorAll(".remove-cart-icon")).concat(Array.from((document.querySelectorAll(".add-adjustment-control"))))
            hideElements.forEach(function (el) {
                el.classList.add('hidden');
            })
            data['html'].map(function (partial) {
                window.postControls.insertAdjacentHTML("beforeEnd", partial);
            })
        } else {
            if (data['result'] === 'retry') {
                document.getElementById('apply-payments-button').disabled = false;
            }
            showFlash([{type: "alert", text: data['message']}]);
        }
    })
        .catch((error) => {
            console.warn(error);
            // Honeybadger.notify(error)
            showFlash([{type: "alert", text: error.message}]);
        })

}